import React, { useState } from "react";
import { View, Text, Pressable, ScrollView } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";
import { Image } from "expo-image";
import Images from "@/assets/images";
import Icons from "@/assets/icons";

interface OptionItemProps {
  image: any;
  selected: boolean;
  onPress: () => void;
}

const OptionItem = ({ image, selected, onPress }: OptionItemProps) => (
  <Pressable
    style={[styles.optionItem, selected && styles.optionItemSelected]}
    onPress={onPress}
  >
    <Image source={image} style={styles.optionImage} contentFit="contain" />
    {selected && (
      <View style={styles.checkmark}>
        <Icons.Check width={14} height={14} />
      </View>
    )}
  </Pressable>
);

interface OnboardSlide4Props {
  onSelectionChange?: (selected: string[]) => void;
}

const OnboardSlide4 = ({ onSelectionChange }: OnboardSlide4Props) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  const options = [
    { id: "expedia", image: Images.brandExpedia },
    { id: "priceline", image: Images.brandPriceline },
    { id: "hotels", image: Images.brandHotels },
    { id: "booking", image: Images.brandBooking },
  ];

  const toggleOption = (optionId: string) => {
    const newSelected = selectedOptions.includes(optionId)
      ? selectedOptions.filter((id) => id !== optionId)
      : [...selectedOptions, optionId];
    setSelectedOptions(newSelected);
    onSelectionChange?.(newSelected);
  };

  return (
    <View style={styles.container}>
      <View style={styles.textContainer}>
        <Text style={styles.title}>
          Have you booked a hotel online before?
        </Text>
        <Text style={styles.subtitle}>
          Pick the ones you booked a hotel from before
        </Text>
      </View>

      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={styles.list}
        showsVerticalScrollIndicator={false}
      >
        {options.map((option) => (
          <OptionItem
            key={option.id}
            image={option.image}
            selected={selectedOptions.includes(option.id)}
            onPress={() => toggleOption(option.id)}
          />
        ))}
      </ScrollView>
    </View>
  );
};

export default OnboardSlide4;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 0,
    paddingTop: 30,
  },
  textContainer: {
    gap: 16,
    marginBottom: 25,
  },
  scrollView: {
    flex: 1,
  },
  title: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 32,
    lineHeight: 38,
    color: "#161D14",
    textAlign: "left",
  },
  subtitle: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 15,
    lineHeight: 24,
    color: "#161D14",
    textAlign: "left",
    opacity: 0.7,
  },
  list: {
    gap: 8,
    paddingBottom: 20,
  },
  optionItem: {
    width: "100%",
    height: 90,
    backgroundColor: "#F3F3F3",
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  optionItemSelected: {
    backgroundColor: "#F3F3F3",
    borderWidth: 2,
    borderColor: "rgba(15, 145, 41, 0.2)",
  },
  optionImage: {
    width: 150,
    height: 40,
  },
  checkmark: {
    position: "absolute",
    top: 5,
    right: 5,
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: "#C6F4A8",
    justifyContent: "center",
    alignItems: "center",
  },
});
